import './more-page.scss';
import React, { useEffect, useRef, useState } from 'react';
import { getCategoryPages, getGenrePages, getTagMorePages } from '../../shared/services/more-page/more-page-service';
import Loading                        from '../../components/loading/item-loading/loading';
import ListView                       from '../../components/list-view/live-view';
import BaseEntity                     from '../../components/base-entity/base-entity';
import ImageGenerator                 from '../../components/image-generator/image-generator';
import { Button }                     from '@material-ui/core';
import { setTitle }                   from '../../shared/services/general/general-service';
import { useConfigApp } from '../../shared/services/general/app-context';
import { Helmet } from 'react-helmet';
import Breadcrumb from '../../components/breadcrumb/breadcrumb';
import { useLocation } from 'react-router-dom';
import { useSeo } from '../../shared/services/general/seoManager';
import SkeletonLoader from '../../components/skeleton-loader/skeleton-loader';

function TagMorePage (props) {
	const [data, setData]                 = useState([]);
	const [tagIsArray, setTagIsArray]     = useState(null);
	const [loading, setLoading]     = useState(true);
	const [page, setPage]                 = useState(0);
	const [showLoadMore, setShowLoadMore] = useState(false);
	const [clearData, setClearData] = useState(true);
	const configApp = useConfigApp();
	const location = useLocation();
	const path = location.pathname;
	const { setSeoData } = useSeo();
	const prevPage = useRef(null);
	const prevId = useRef(null);

	useEffect(() => {
		if (path.includes('/category/')) {
			setTagIsArray(true)
			getCategoryPagesApi()
		} else if (path.includes('/genre/')) {
			setTagIsArray(true);
			getGenrePagesApi()
		} else {
			getTagMorePagesApi()
		}
	}, [])
	useEffect(() => {
		if (clearData) {
			setData([]);
			setLoading(true);
			setPage(0);
		}

		if ((path.includes('/category/')) || (path.includes('/genre/'))) {
			if (prevPage.current !== null && prevId.current !== null) {
				if (prevPage.current !== page || prevId.current !== props.match.params.id) {
					if (path.includes('/category/')) {
						setTagIsArray(true);
						getCategoryPagesApi();
					} else if (path.includes('/genre/')) {
						setTagIsArray(true);
						getGenrePagesApi()
					}
				}
			}
		} else {
			getTagMorePagesApi();
		}
	}, [page,  path]);

	useEffect(() => {
		setData([]);
		setLoading(true);
		setPage(0);
	}, [path]);

	const getTagMorePagesApi = () => {
		getTagMorePages(props.match.params.id, props.match.params.type, page).then(
			(res) => {
				const responseType = Array.isArray(res.data.data);
				setTagIsArray(responseType);
				if (responseType) {
					const newData = res.data.data;
					setShowLoadMore(newData.length >= 199);
					setClearData(true);
					setData((prevData) => [...prevData, ...newData]);
					setLoading(false);
				} else {
					setShowLoadMore(false);
					setData(res.data.data);
					setLoading(false);
					setTitle(`${configApp?.title} | ${res.data.data.value}`);
				}
			},
		).catch((error) => {
			setLoading(false);
		}).finally(() => {
			setTimeout(() => {
				setLoading(false);
			}, 500)
		});
	}

	const getCategoryPagesApi = () => {
		prevPage.current = page;
		prevId.current = props.match.params.id;
		getCategoryPages(props.match.params.id, props.match.params.type, page, 200).then(
			(res) => {
				if (res.data.code === 200) {
					const newData = res.data.data;
					setShowLoadMore(newData?.totalPages > page + 1);
					setLoading(false);
					setClearData(true);
					if (page === 0) {
						setData((prevData) => ({
							...prevData,
							category: newData.category,
							totalPages: newData.totalPages,
							totalContentCount: newData.totalContentCount,
							contents: newData.contents,
						}));
						setSeoData({
							title: `${newData?.category?.name} | ${configApp?.title}`,
							image: newData?.category?.image,
							description: newData?.category?.description || null,
						});
						setTitle(`${newData?.category?.name} | ${configApp?.title}`);
					} else {
						setData((prevData) => ({
							...prevData,
							contents: [...(prevData.contents || []), ...newData.contents],
						}));
					}
				}

			},
		).catch((error) => {
			setLoading(false);
		}).finally(() => {
			setTimeout(() => {
				setLoading(false);
			}, 500)
		});
	}

	const getGenrePagesApi = () => {
		prevPage.current = page;
		prevId.current = props.match.params.id;
		getGenrePages(props.match.params.id, props.match.params.type, page, 200).then(
			(res) => {
				if (res.data.code === 200) {
					const newData = res.data.data;
					setShowLoadMore(newData?.totalPages > page + 1);
					setLoading(false);
					setClearData(true);
					if (page === 0) {
						setData((prevData) => ({
							...prevData,
							genre: newData.genre,
							totalPages: newData.totalPages,
							totalContentCount: newData.totalContentCount,
							contents: newData.contents,
						}));
						setSeoData({
							title: `${newData?.genre?.name} | ${configApp?.title}`,
							image: newData?.genre?.image,
							description: newData?.genre?.description,
						});
						setTitle(`${newData?.genre?.name} | ${configApp?.title}`);
					} else {
						setData((prevData) => ({
							...prevData,
							contents: [...(prevData.contents || []), ...newData.contents],
						}));
					}
				}

			},
		).catch((error) => {
			setLoading(false);
		}).finally(() => {
			setTimeout(() => {
				setLoading(false);
			}, 500)
		});
	}


	useEffect(() => {
		if (data && data?.value && !tagIsArray) {
			setSeoData({
				title: `${data?.value} | ${configApp?.title}`,
				image: data?.fields?.image,
				description: null,
			});
		}

	}, [data, tagIsArray, configApp]);

	if (loading) {
		return (
			<>
				<div style={{padding: '0 40px'}}>
					<div className="skeleton-loader-items" style={{ paddingRight: '10px', paddingBottom: '30px' }}>
						<div className="d-flex" style={{ gap: '20px', marginTop: '88px', marginBottom: '20px' }}>
							<SkeletonLoader type="text" count={1} width={'70px'} height={'12px'} />
							<SkeletonLoader type="text" count={1} width={'70px'} height={'12px'} />
							<SkeletonLoader type="text" count={1} width={'70px'} height={'12px'} />
						</div>
						<SkeletonLoader type="text" count={1} width={'70px'} height={'20px'} />
					</div>

					<div style={{ padding: '0 18px' }}>
						<SkeletonLoader type="items" count={49} />
					</div>
				</div>
			</>
		);
	} else if (!data || data?.length === 0 || data?.contents?.length === 0) {
		return (
			<>
				<p style={{ color: 'white', fontSize: '16px', textAlign: 'center', marginTop: '100px' }}>
					متاسفانه محتوایی برای نمایش وجود ندارد
				</p>
			</>
		);
	}

	const renderTagObject = () => {
		return (
			<div>
				{
					configApp?.titleEn !== 'bebin' && (<Helmet>
						<meta name="robots" content="noindex, follow" />
					</Helmet>)
				}
				<div className="warp">
					<Breadcrumb
						style={{ marginBottom: '-4px' }}
						firstItem={{ label: 'خانه', path: '/' }}
						currentItem={data?.value}
					/>
					<div className="tag-info">
						<div className="tag-header">
							<div className="tag-background-image"
								 style={{ backgroundImage: `url(${data?.fields?.image})` }}/>
							<div className="tag-info-box">
								{data?.tagDefinitionName !== 'genre' && data?.tagDefinitionName !== 'category' && (
									<div className="tag-image">
										<ImageGenerator src={data?.fields?.image}
														name={data?.value} />
									</div>
								)}
							</div>
						</div>
						<div className="tag-body">
							<h1>{data?.value}</h1>
							{data?.fields?.bio && (
								<>
									<br />
									<p>{data?.fields?.bio}</p>
								</>
							)}
						</div>
					</div>
				</div>
				<BaseEntity data={data?.carousels} />
			</div>
		);
	};

	return (
		<div className={`list-view-container${' ' + data?.tagDefinitionName}`}>
			{tagIsArray ? <ListView data={data}
									type={props.match.params.type} /> : renderTagObject()}
			{showLoadMore ? <Button onClick={() => {
				setPage(page + 1);
				setClearData(false);
			}}
									hidden={page === 0 && loading}
									disabled={loading}
									variant={'contained'}
									className="load-more">
				<span>موارد بیشتر</span>
			</Button> : null}
		</div>
	);
}

export default TagMorePage;
